import React, { useEffect, useState } from "react";
import Columns from "./Columns";
import { paymentsMethodsResource } from "../../../helpers/configRoutes/backend_helper";
import DataTableElement from "../../../components/elements/DataTableElement";
import CustomButton from "../../../components/form/CustomButton";
import AddUpdMethodsModal from "./AddUpdMethodsModal";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentMethods = () => {
    const userStore = useSelector((state) => state.Login.user) || {};
    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading payment methods...",
    });
    const [data, setData] = useState([]);
    const [modal, setModal] = useState({ show: false, title: "" });
    const [item, setItem] = useState({ id: null });

    const getMethods = async () => {
        setTableLoad((prev) => ({ ...prev, show: true }));
        const response = await paymentsMethodsResource("get", {});
        setData(response.methods || []);
        setTableLoad((prev) => ({ ...prev, show: false }));
    };

    useEffect(() => {
        getMethods();
    }, []);

    const openModalAdd = (method = {}) => {
        setItem(method);
        setModal({
            ...modal,
            show: true,
            title: method.id ? "Edit payment method" : "Add payment method",
        });
    };

    const cols = Columns({ openModalAdd });

    return (
        <div className="min-h-screen bg-cs-bg-alt py-8 px-4">
            <div className="max-w-auto mx-auto space-y-4">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.18em] text-cs-muted">
                            Billing center
                        </p>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Payment methods
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage your saved cards and choose a primary method for automatic charges.
                        </p>
                    </div>
                    <div className="flex justify-end">
                        {userStore.can.CompanyPaymentMethod.create &&
                            <CustomButton
                                onClick={() => openModalAdd({})}
                                className="
                                px-4 py-2 rounded-xl
                                bg-cs-primary
                                hover:bg-cs-primary-hover
                                text-white
                                text-[10px] font-medium
                                shadow-sm hover:shadow-md
                                inline-flex items-center gap-1.5
                            "
                            >
                                <span className="material-symbols-outlined text-[16px]">
                                    add
                                </span>
                                Add new method
                            </CustomButton>
                        }
                    </div>
                </div>

                {/* Table */}
                <div className="bg-cs-bg border border-cs-border rounded-2xl shadow-sm overflow-hidden">
                    <DataTableElement
                        columns={cols}
                        items={data}
                        tableLoad={tableLoad}
                    />
                </div>

                {/* Modal envuelto con Stripe Elements */}
                <Elements stripe={stripePromise}>
                    <AddUpdMethodsModal
                        modal={modal}
                        setModal={setModal}
                        item={item}
                        refresh={getMethods}
                    />
                </Elements>
            </div>
        </div>
    );
};

export default PaymentMethods;
